import { useEffect, useState } from 'react';
import keyPayEmployeeService from '../../../services/KeypayEmployee';

export default function useFetchKeyPayEmployeeRecords() {
  const [keyPayEmployeeRecords, setKeyPayEmployeeRecords] = useState([]);
  const [keyPayError, setKeyPayError] = useState('');
  const [keyPayLoading, setKeyPayLoading] = useState(false);

  useEffect(() => {
    const fetchKeyPayEmployeeRecords = async () => {
      try {
        setKeyPayLoading(true);
        setKeyPayError('');
        const keyPayEmployees = await keyPayEmployeeService.getAllKeyPayEmployeeList();

        const keyPayEmployeeRecords = keyPayEmployees.data.data;
        setKeyPayEmployeeRecords(keyPayEmployeeRecords);
      } catch (error) {
        setKeyPayEmployeeRecords([]);
        setKeyPayError(error?.response?.data?.message || error?.message || 'Could not fetch KeyPay employees');
      } finally {
        setKeyPayLoading(false);
      }
    };
    fetchKeyPayEmployeeRecords();
  }, []);

  return { keyPayEmployeeRecords, keyPayError, keyPayLoading };
}
